import { render, staticRenderFns } from "./PublicNumber.vue?vue&type=template&id=be26741c&"
import script from "./PublicNumber.vue?vue&type=script&lang=js&"
export * from "./PublicNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports